import __request__ from "routing/request";
export function index(requestOptions) {
  return __request__("GET", "/system/indexer/overview", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function indexByindexSetId(indexSetId, requestOptions) {
  return __request__("GET", `/system/indexer/overview/${indexSetId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
